import {updateGame} from "./index";

export function fetchDeeplinkForGame(gameId, isPublic, callback, errorCallback = null) {

   deeplinkCall(gameId, isPublic)
      .then(response => {
         if (response.status !== 200) {
            let msg = response.statusText;
            if (!msg) msg = "status code: " + response.status;
            errorCallback(msg)
            return;
         }
         response.json()
            .then(data => {
               updateGame(gameId, isPublic, { deepLink: data.shortLink }, callback );
         })
         // should do spinner and callback for these things.
      })
      .catch( (error) => {
         console.warn("Unable to get deeplink.  Error=", error);
         const msg = error.message ? error.message : "No error message."
         if (errorCallback) {
            errorCallback(msg)
         }
      })
}

function deeplinkCall(gameId, isPublic = false) {

   const deeplink = "https://ourtreasurehunt.com/?payload=" + gameId + (isPublic ? "&pub=true" : "");


   const url = "https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyBPWEHbVaZk3rIT8bYyIIeDTis4TIcUrUs";
   const data = {
      dynamicLinkInfo: {
         domainUriPrefix: "https://ourtreasurehunt.page.link",
         link: deeplink,
         androidInfo: {
            androidPackageName: "com.ourtreasurehunt",
            androidMinPackageVersionCode: "38"          // force upgrade below 38.  This is our last version.
         },
         iosInfo: {
            iosBundleId: "com.ourtreasurehunt.treasurehuntios",
            // need this ??  don't think so, but here it is.
            iosAppStoreId: "1413911129"
         },
         socialMetaTagInfo: {
            socialTitle: "Our Treasure Hunt",
            socialDescription: "Check out the world's best platform for building and playing treasure hunts.",
            socialImageLink: "https://images.squarespace-cdn.com/content/5aea3e3b297114b0c2374ec0/1553102277245-G0L1C5RA8U90LWABX1P7/diamond+circle+blue.png?content-type=image%2Fpng"
         }
         // ETC. See https://firebase.google.com/docs/reference/dynamic-links/link-shortener
      },
      suffix: {
         option: "SHORT"
      }
   }

   return postData(url, data);
}

// Example POST method implementation:
function postData(url = '', data = {}) {
   const json = JSON.stringify(data);

   return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: json
   });

   // // Default options are marked with *
   // return fetch(url, {
   //    method: 'POST', // *GET, POST, PUT, DELETE, etc.
   //    headers: {
   //       'Content-Type': 'application/json'
   //       // 'Content-Type': 'application/x-www-form-urlencoded',
   //    },
   //    body: JSON.stringify(data), // body data type must match "Content-Type" header
   //    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
   //
   //    mode: 'cors', // no-cors, *cors, same-origin
   //    credentials: 'same-origin', // include, *same-origin, omit
   //    redirect: 'follow', // manual, *follow, error
   //    referrerPolicy: 'no-referrer-when-downgrade' // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
   // });
}


// WEBPACK FOOTER //
// ./src/actions/restcalls.js